// Callback origin for KesPay deposit / withdraw redirects.
// Sourced from the live `window.location.origin` so the URLs we send to
// KesPay always match whatever host the app is being served from —
// localhost during dev, the partner domain in production, any preview
// build, etc. (Provided KesPay's merchant config has the relevant
// origins whitelisted on their side.) Guarded with `typeof window` for
// the rare SSR / pre-render import path.

export const PAYMENT_CALLBACK_ORIGIN =
  (typeof window !== 'undefined' && window.location?.origin) || '';

export const PAYMENT_STATUS_PATHS = {
  success: '/payment-confirm',
  cancel: '/payment-cancel',
  fail: '/payment-fail',
  pending: '/payment-pending',
};

export const PAYMENT_STATUS_URLS = {
  success: `${PAYMENT_CALLBACK_ORIGIN}${PAYMENT_STATUS_PATHS.success}`,
  cancel: `${PAYMENT_CALLBACK_ORIGIN}${PAYMENT_STATUS_PATHS.cancel}`,
  fail: `${PAYMENT_CALLBACK_ORIGIN}${PAYMENT_STATUS_PATHS.fail}`,
  pending: `${PAYMENT_CALLBACK_ORIGIN}${PAYMENT_STATUS_PATHS.pending}`,
};

// sessionStorage keys used to carry context across the KesPay redirect
// roundtrip (full-page navigation, so Redux state is lost between leaving
// and returning). sessionStorage is per-tab and persists across reloads
// inside the same tab, which is exactly what we need.
//
//   PENDING_PAYMENT_STORAGE_KEY: { type: 'deposit' | 'withdraw',
//                                  initiatedAt: number }
//     Set by mpesaDeposit / mpesaWithdraw right before redirecting; read
//     by PaymentCallbackBridge to decide which verb ("Deposit" /
//     "Withdrawal") to use in the toast.
//
//   MPESA_PLAYER_STORAGE_KEY: serialized terminal.playerInfo
//     The M-Pesa "logged in" player (PaymentsPlayerId, PersonalId, etc.)
//     is held in Redux only. Redux is reset on the full-page redirect,
//     so we serialise it here and PaymentCallbackBridge re-applies it via
//     `PaymentsService.setPlayerInfo` so the user comes back logged in.
export const PENDING_PAYMENT_STORAGE_KEY = 'mpesaPendingPayment';
export const MPESA_PLAYER_STORAGE_KEY = 'mpesaPlayerInfo';

// Query-string outcome KesPay actually uses in practice — observed live as
// `?status=success&reference=<id>` regardless of what we send in the
// request body's `status_urls`. We normalise common variants
// (success/succeeded, fail/failed/failure, cancel/cancelled/canceled,
// pending/processing) so the handler doesn't break on backend wording
// changes.
export const PAYMENT_STATUS_QUERY_PARAM = 'status';
export const PAYMENT_REFERENCE_QUERY_PARAM = 'reference';

export const normalisePaymentStatus = (raw) => {
  if (!raw) return null;
  const v = String(raw).toLowerCase();
  if (v === 'success' || v === 'succeeded' || v === 'ok') return 'success';
  if (v === 'fail' || v === 'failed' || v === 'failure' || v === 'error') return 'fail';
  if (v === 'cancel' || v === 'cancelled' || v === 'canceled') return 'cancel';
  if (v === 'pending' || v === 'processing' || v === 'in_progress') return 'pending';
  return null;
};
